import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { CardNumberElement, useElements } from '@stripe/react-stripe-js';
import * as S from '../stripe-inputs.style';

export type StripeElementRef = {
  focus: () => void;
};

type Props = {
  containerId?: string;
  elementId?: string;
  onStripeChange?: (
    field: 'number' | 'expiry' | 'cvc',
    state: { complete: boolean; error: string | null },
  ) => void;
  variant?: 'classic' | 'modern';
  color?: string;
};

export const StripeCardInput = forwardRef<StripeElementRef, Props>(
  (
    {
      containerId = 'stripe-card-number-container',
      elementId = 'stripe-card-number',
      onStripeChange,
      variant = 'classic',
      color,
    },
    ref,
  ) => {
    const [isFocused, setIsFocused] = useState(false);
    const elements = useElements();

    useImperativeHandle(ref, () => ({
      focus() {
        const el = elements?.getElement(CardNumberElement);
        el?.focus();
      },
    }));

    return (
      <S.Content id={containerId}>
        <S.InputWrapper>
          <S.StyledStripeElement
            color={color}
            $focused={isFocused}
            $variant={variant}
          >
            <CardNumberElement
              id={elementId}
              onChange={(e) =>
                onStripeChange?.('number', {
                  complete: e.complete,
                  error: e.error?.code ?? null,
                })
              }
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              options={{
                placeholder: '0000 0000 0000 0000',
                style: {
                  base: {
                    '::placeholder': {
                      color: '#9ca3af',
                    },
                  },
                  invalid: {
                    color: '#000',
                  },
                },
              }}
            />
          </S.StyledStripeElement>
        </S.InputWrapper>
      </S.Content>
    );
  },
);
